var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ListSelection',{attrs:{"List":_vm.giftcardslist,"Label":_vm.$t('gift_card'),"Placeholder":_vm.$t('choose_gift_card')},on:{"selection":_vm.action}}),_c('BasicStatisticsRow',{key:_vm.componentKey,attrs:{"basicstatisticspath":_vm.giftcardstatisticspathbasic}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }